<template>
    <v-card width="100%" max-width="600px">
        <v-card-title>
            Login
        </v-card-title>

        <v-card-text>
            <login-form
                v-model="loginForm"
                @submit="submit"/>
        </v-card-text>
        <v-card-actions>
            <v-spacer/>

            <v-btn
                color="primary"
                @click="submit">
                {{ $t('button.login') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import LoginForm from '@/components/forms/LoginForm'

export default {
    name: 'LoginView',

    components: {
        LoginForm
    },

    data () {
        return {
            loginForm: {
                email: '',
                password: ''
            }
        }
    },

    methods: {
        async submit () {
            try {
                await this.$store.dispatch('login', this.loginForm)
            } catch (error) {
                if (error?.response?.status === 401) {
                    this.$app.alert('Unauthorized', 'Username or password is incorrect!')
                    return
                }

                throw error
            }

            this.$emit('logged-in')
        }
    }
}
</script>

<style lang="scss" scoped></style>
